import { swap2MinMax } from "./swap-2-min-max";

export const isWithinRange = (
  value: number,
  from: number,
  to: number,
  inclusive = true,
): boolean => {
  // const inclusivity = Number(inclusive);
  // const [min, max] = swap2MinMax(from, to);
  // return value > min - inclusivity && value < max + inclusivity;
  const [min, max] = swap2MinMax(from, to);
  if (inclusive) {
    return value >= min && value <= max;
  } else {
    return value > min && value < max;
  }
};
